import Vue from 'vue';
import Vuelidate from 'vuelidate';
import '@mdp/mdp-ui-kit/dist/mdp-ui-kit.css';
import {
  AppCheckbox,
  AppFormField,
  UnmaskField,
  RulesetList,
  RulesetItem,
  AppAlert,
} from '@mdp/mdp-ui-kit';
import {
  not,
  sameAs,
  required,
  minLength,
} from 'vuelidate/lib/validators';
import LanguageSelect from '@/components/LanguageSelect.vue';
import {
  MESSAGE_ALERT_TYPE_MAP,
  MIN_PASSWORD_LENGTH,
  REGEX_DIGITS,
  REGEX_LOWERCASE,
  REGEX_SPECIAL,
  REGEX_UPPERCASE,
} from '@/scripts/constants';
import { emailWithUppercase } from '@/scripts/utils';

Vue.use(Vuelidate);

export default new Vue({
  components: {
    AppCheckbox,
    AppFormField,
    LanguageSelect,
    UnmaskField,
    RulesetList,
    RulesetItem,
    AppAlert,
  },
  data() {
    return {
      MIN_PASSWORD_LENGTH,
      isRememberMe: IS_REMEMBER_ME,
      isLoading: false,
      isPasswordUnmasked: false,
      isAgreeTermsAndConditionsChange: false,
      alertType: MESSAGE_ALERT_TYPE_MAP[MESSAGE_TYPE],
      emailForCheck: USERNAME,
      loginUsername: LOGIN_USERNAME,
      email: '',
      passwordNew: '',
      passwordConfirm: '',
    };
  },
  validations: {
    loginUsername: {
      required,
      emailWithUppercase,
    },
    email: {
      required,
      emailWithUppercase,
    },
    passwordNew: {
      required,
      matchCharRegex: (value) => (REGEX_DIGITS.test(value) || REGEX_SPECIAL.test(value))
          && REGEX_LOWERCASE.test(value)
          && REGEX_UPPERCASE.test(value),
      notSameAsEmail: not(sameAs('emailForCheck')),
      minLength: minLength(MIN_PASSWORD_LENGTH),
    },
    passwordConfirm: {
      required,
      sameAsPassword: sameAs('passwordNew'),
    },
    isAgreeTermsAndConditionsChange: {
      required: sameAs(() => true),
    },
    loginGroup: ['loginUsername'],
    resetPasswordRequestGroup: ['email'],
    resetPasswordGroup: ['passwordNew', 'passwordConfirm'],
    termsGroup: ['isAgreeTermsAndConditionsChange'],
  },
  methods: {
    handleSubmitLogin(e: Event) {
      this.$v.loginGroup.$touch();

      if (this.$v.loginGroup.$invalid) {
        e.preventDefault();
        return;
      }

      this.isLoading = true;
    },
    handleSubmitResetPasswordRequest(e: Event) {
      this.$v.resetPasswordRequestGroup.$touch();

      if (this.$v.resetPasswordRequestGroup.$invalid) {
        e.preventDefault();
        return;
      }

      this.isLoading = true;
    },
    handleSubmitResetPassword(e: Event) {
      this.$v.resetPasswordGroup.$touch();

      if (this.$v.resetPasswordGroup.$invalid) {
        e.preventDefault();
        return;
      }

      this.isLoading = true;
    },
    handleSubmitAcceptTerms(e: Event) {
      this.$v.termsGroup.$touch();

      if (this.$v.termsGroup.$invalid) {
        e.preventDefault();
        return;
      }

      this.isLoading = true;
    },
    setFocus(field: HTMLInputElement) {
      field.focus();

      // need to wait tick when caret appears in the field
      setTimeout(() => {
        const cursorPosition = field.value.length;

        /* eslint-disable no-param-reassign */
        field.selectionStart = cursorPosition;
        field.selectionEnd = cursorPosition;
        /* eslint-enable no-param-reassign */
      }, 0);
    },
  },
});
